import React from "react";
import { Link } from "react-router-dom";
import { Twitter, Instagram, Linkedin } from "lucide-react";
import { ProsperLogo } from "./ProsperLogo";

export const SiteFooter = () => (
  <footer
    data-testid="footer"
    className="mt-16 sm:mt-20 border-t border-slate-100 py-8"
  >
    <div className="mx-auto max-w-7xl px-6 lg:px-10 flex flex-col md:flex-row items-center justify-between gap-6">
      <ProsperLogo size="sm" testId="footer-logo" />

      <p className="text-sm text-slate-500">
        © 2026 Prosper.AI. All rights reserved.
      </p>

      <div className="flex items-center gap-6">
        <a data-testid="footer-privacy-link" href="#privacy" className="text-sm text-slate-600 hover:text-slate-900">
          Privacy Policy
        </a>
        <Link to="/investors" data-testid="footer-investors-link" className="text-sm text-slate-600 hover:text-slate-900">
          Investors
        </Link>
        <Link to="/media" data-testid="footer-media-link" className="text-sm text-slate-600 hover:text-slate-900">
          Media
        </Link>
        <div className="flex items-center gap-3">
          {[
            { key: "twitter", Icon: Twitter, href: "#twitter" },
            { key: "instagram", Icon: Instagram, href: "#instagram" },
            { key: "linkedin", Icon: Linkedin, href: "#linkedin" },
          ].map(({ key, Icon, href }) => (
            <a
              key={key}
              data-testid={`footer-social-${key}`}
              href={href}
              className="grid h-8 w-8 place-items-center rounded-full bg-slate-100 text-slate-600 hover:bg-slate-200"
            >
              <Icon className="h-4 w-4" />
            </a>
          ))}
        </div>
      </div>
    </div>
  </footer>
);

export default SiteFooter;
